import(/* webpackMode: "eager" */ "D:\\MyPC\\Projects\\raw-figures-website\\src\\server\\app\\@body\\default.tsx");
